import React, { useEffect, useRef, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { AngleRight } from "../assets/Icons";
import { BackArrowIcon, defaultLogo } from "../Icons";
import apiClient from "../apiClient";
import { CHANGE_PARENT } from "../apiClient/apiEndpoints";
import { useSelector } from "react-redux";
import { debounce, getPlaceholderName, modalName } from "../utils/general";
import { useModalContext } from "./context/ModalProvider";
import { GROUP_TAB_TYPE, TABS_TYPE_KEY, USER_TAB_TYPE } from "../constant/constants";

const { BackButton, SimInputBar, SimTooltip, DropdownSearch } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const Move = () => {
  const { modalState, openModal, closeModal } = useModalContext();
  const { type, handleRefreshTab, transferData, handleClearSelection } = modalState;
  const configData = useUnoSelector((state) => state.config);
  const groupData = useSelector((state) => state.groupSlice);
  const [currentGroup, setCurrentGroup] = useState({ name: null, id: null, avatar: null });
  const [activeGroupPath, setActiveGroupPath] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [slug, setSlug] = useState("");
  const clickTimeout = useRef(null);
  const [groupHierarchy, setAllGroupsHierarchy] = useState({
    list: [],
    hierarchy: [],
  });
  const [error, setError] = useState(null);
  const getInitials = (e) => {
    if (!e) return "";
    return e.split(" ").slice(0, 2).map((e) => e.at(0)).join("").toUpperCase();
  };

  useEffect(() => {
    const typeMapping = {
      [USER_TAB_TYPE]: transferData[0]?.data?.group,
      [GROUP_TAB_TYPE]: transferData[0]?.data?.parent,
    };
    const data = typeMapping[type];
    if (data) {
      setCurrentGroup({ name: data.name, id: data.uuid, avatar: data.avatar });
    }
  }, [transferData]);

  useEffect(() => {
    setAllGroupsHierarchy({
      list: groupData?.allChildren?.map((e) => ({ value: e.uuid, label: e.name, avatar: e.avatar })) || [],
      hierarchy: groupData?.allHierarchy ? [groupData?.allHierarchy] : [],
    });
  }, [groupData]);

  const handleCancelModal = () => {
    closeModal();
    setSelectedGroup(null);
  };

  const handleMoveResource = async (data = null) => {
    let movingData = {};
    let selectedItem = data || selectedGroup;
    let actionTab = TABS_TYPE_KEY[type];
    if (!selectedItem) {
      setError("Kindly select group");
      return;
    }

    try {
      let bodyData = {
        ids: transferData.map((e) => e.id),
        parentId: selectedItem.id,
      };

      if (bodyData.ids.includes(bodyData.parentId)) {
        setError("You are trying to move selected group into same group");
        return;
      }

      movingData["transfer"] = {
        type: TABS_TYPE_KEY[type],
        data: transferData.map((item) => ({ name: item.data.name, avatar: item.data.avatar })),
      };
      movingData["receiver"] = {
        type: "group",
        data: [{ name: selectedItem.name, avatar: selectedItem.avatar }],
      };

      openModal({
        modalName: modalName.SUCCESSFULLY_POPUP,
        message: `${type} is moving`,
        transferring: true,
        movingData,
        modalSize: "lg",
      });

      await apiClient.post(`${configData.config.UNO_URL}${CHANGE_PARENT}/${actionTab}`, bodyData);

      openModal({
        modalName: modalName.SUCCESSFULLY_POPUP,
        message: "Moved Successfully.",
        transferring: false,
        movingData,
      });

      handleClearSelection();

      setTimeout(() => {
        handleRefreshTab();
        handleCancelModal();
      }, 500);
    } catch (error) {
      console.log(error);
      setError(error?.response?.data?.message || error?.message);
    }
  };

  const handleGroupSingleClick = (group) => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }
    setError(() => null);
    clickTimeout.current = setTimeout(() => {
      setSelectedGroup(group);
    }, 400);
  };

  const handleGroupDoubleClick = (group) => {
    setSlug("");
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }
    setActiveGroupPath([...activeGroupPath, group]);
  };

  const handleBack = () => {
    setActiveGroupPath(activeGroupPath.slice(0, -1));
    setSlug("");
  };

  const onSlugChangeHandler = (e) => {
    setSlug(e.target.value);
  };

  let currentLevel =
    activeGroupPath.length === 0
      ? groupHierarchy.hierarchy
      : activeGroupPath[activeGroupPath.length - 1].children || [];

  if (slug) {
    currentLevel = currentLevel?.filter((item) => item.name?.toLowerCase()?.includes(slug?.toLowerCase()));
  }

  const handelSubmitDebounce = debounce(() => handleMoveResource(null), 500);

  return (
    <div className="moveggroup">
      <div className="move-body pb-0">
        <div className="movegropheader">
          <div className="info-state mb-1">
            <h6 className="d-flex align-items-center m-0">
              Moving
              {transferData && (
                <>
                  {transferData.length === 1 ? (
                    <>
                      <div className="group-view border-0">
                        <div>
                          {transferData[0].data.avatar ? (
                            <div className="thumbnail">
                              <img
                                src={transferData[0].data.avatar}
                                className="group-avatar"
                                referrerPolicy={"no-referrer"}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.insertAdjacentHTML('afterend', `<span class="avatar-placeholder">${(transferData[0].data.name)}</span>`);
                                }}
                              />
                            </div>
                          ) : (
                            <div className="avatar-placeholder">
                              {transferData[0].data.name
                                ?.split(" ")
                                ?.slice(0, 2)
                                ?.map((word) => word?.charAt(0))
                                ?.join("")
                                ?.toUpperCase()}
                            </div>
                          )}
                        </div>
                        <p>{transferData[0].data.name}</p>
                      </div>
                    </>
                  ) : (
                    `${transferData.length} ${type} selected`
                  )}
                </>
              )}
            </h6>
          </div>
          <div className="info-state mb-2">
            <h6 className="m-0 ">Current Group: </h6>
            {currentGroup && (
              <div className="group-view">
                <div>
                  {currentGroup?.avatar ? (
                    <div className="thumbnail">
                      <img
                        src={currentGroup?.avatar}
                        className="group-avatar"
                        referrerPolicy={"no-referrer"}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.insertAdjacentHTML('afterend', `<span class="avatar-placeholder">${getInitials(currentGroup?.name)}</span>`);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="avatar-placeholder">
                      {currentGroup?.name
                        ?.split(" ")
                        ?.slice(0, 2)
                        ?.map((e) => e?.charAt(0))
                        ?.join("")
                        ?.toUpperCase()}{" "}
                    </div>
                  )}
                </div>
                <p> {currentGroup?.name} </p>
              </div>
            )}
          </div>
          {selectedGroup && (
            <div className="info-state  mb-2">
              <h6 className="m-0 ">Selected Group: </h6>
              <div className="group-view">
                <div>
                  {selectedGroup?.avatar ? (
                    <div className="thumbnail">
                      <img src={selectedGroup?.avatar} className="group-avatar" referrerPolicy={"no-referrer"}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.insertAdjacentHTML('afterend', `<span class="avatar-placeholder">${getInitials(currentGroup?.name)}</span>`);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="avatar-placeholder">
                      {selectedGroup?.name
                        ?.split(" ")
                        ?.slice(0, 2)
                        ?.map((e) => e?.charAt(0))
                        ?.join("")
                        ?.toUpperCase()}{" "}
                    </div>
                  )}
                </div>
                <p> {selectedGroup?.name} </p>
              </div>
            </div>
          )}
        </div>

        {/* <DropdownSearch
          selectProps={{
            options: groupHierarchy.list,
            value: selectedOption,
            onChange: (e) => handleSelectDropdownGroup(e),
            placeholder: "Select an option...",
            isClearable: true,
            isMulti: false,
          }}
        /> */}

        <div className="moveinput">
          <SimInputBar value={slug} onChange={onSlugChangeHandler} placeholder="Search Group" />
        </div>

        <div className="movable-list py-2">
          <div className="list-title-here">
            {activeGroupPath.length > 0 && <BackButton onBackClick={handleBack} Icon={<BackArrowIcon />} />}{" "}
            <p> {activeGroupPath.length > 0 ? activeGroupPath[activeGroupPath.length - 1].name : "  Group List"}</p>
          </div>

          <div className="move-scroll">
            {currentLevel.map((group) => (
              <div
                key={group.id}
                className={`move-item ${selectedGroup && selectedGroup.id === group.id && "active"}`}
                onClick={() => handleGroupSingleClick({ name: group.name, avatar: group.avatar, id: group.id })}
                onDoubleClick={() => handleGroupDoubleClick(group)}
              >
                <div className={`group-view`}>
                  <div>
                    {group.avatar ? (
                      <div className="thumbnail">
                        <img
                          src={group.avatar}
                          alt={`${group.name} Avatar`}
                          className="group-avatar"
                          referrerPolicy="no-referrer"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.insertAdjacentHTML('afterend', `<span class="avatar-placeholder">${getInitials(group.name)}</span>`);
                          }}
                        />
                      </div>
                    ) : (
                      <div className="avatar-placeholder">{getPlaceholderName(group.name)}</div>
                    )}
                  </div>
                  <span>{group.name}</span>
                </div>

                <div className="group-view with-move">
                  <span style={{ cursor: "pointer" }} onClick={() => handleGroupDoubleClick(group)}>
                    <AngleRight />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="modal-footer justify-content-end">
        <div>
          <div className="modal-footer-btns justify-content-end">
            <button onClick={handleCancelModal} className="cancel">
              Cancel
            </button>
            <SimTooltip text={error ? error : selectedGroup ? "Click to move" : "Kindly select group"}>
              <button disabled={error || !selectedGroup} onClick={handelSubmitDebounce} className="save">
                Move
              </button>
            </SimTooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Move;
